import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IPagedBalanceHistoryResultRequestDto, IPagedOrderHistoryResultRequestDto } from 'src/app/models/backend';
import { PagedResultDto } from 'src/app/shared/components/paged-listing-component-base';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrderHistoryService {
  id: any;
  Token = localStorage.getItem("Token")
  headers = new HttpHeaders()
    .set('Content-Type', 'application/json; charset=utf-8')
    .set('Authorization', `Bearer ${this.Token}`);
  constructor(private http: HttpClient) { }
  
  readonly url = environment.apiUrl+'Orders/'
  readonly url1 = environment.apiUrl + 'OrderItems/';



  getOrderReport(payload) {
    return this.http.post(this.url + 'OrderReport', payload, { headers: this.headers });
  }
  getItembyOrderNumber(orderNumber: string) {
    const url = `${this.url1}OrderItemsByOrderNumber?orderNumber=${orderNumber}`;
    return this.http.post(url, {}, { headers: this.headers });
}

UpdateStatus(newStatus)
{
  debugger
 return this.http.post(this.url+'UpdateOrder',newStatus,{headers:this.headers});
}

getoldStatusbyOrderId(ordernumber)
{
  const url = `${this.url}OrderById?ordernumber=${ordernumber}`;

  return this.http.post(url, {}, { headers: this.headers });

}
debugger
generateBulkReport(filters)
{
  return this.http.post(this.url + ' PrintCustomerDeliveryReciptBulk', filters, { headers: this.headers });

}
}
